/**
 * (Managed)MediaSource capability helpers. ManagedMediaSource is iOS Safari's
 * (>= 17.1) managed variant and is preferred when present. The globals are
 * resolved at call time — never cached at module load — so late polyfills and
 * test doubles are picked up.
 */

export const audioMime = (codec: string) => `audio/mp4; codecs="${codec}"`;

function getManagedMediaSourceCtor(): typeof MediaSource | undefined {
  return (globalThis as Record<string, unknown>)['ManagedMediaSource'] as
    | typeof MediaSource
    | undefined;
}

export function pickMediaSourceCtor(): typeof MediaSource | null {
  const managed = getManagedMediaSourceCtor();
  if (managed) return managed;
  if (typeof MediaSource !== 'undefined') return MediaSource;
  return null;
}

export function isManagedMediaSource(ctor: typeof MediaSource): boolean {
  return ctor === getManagedMediaSourceCtor();
}

export function base64ToUint8Array(b64: string): Uint8Array {
  const bin = atob(b64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
